import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { CREW } from "./TeamThanks";

export const TeamTeaser = () => (
  <section data-testid="home-team-teaser" className="py-20 lg:py-28 bg-[#1B1530] text-white">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-8 grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
      <Reveal className="lg:col-span-5">
        <Eyebrow className="text-[#FFB21A] mb-4">The team behind the bears</Eyebrow>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">It started with just me. It's not just me anymore.</h2>
        <p className="mt-5 text-base sm:text-lg text-zinc-300 leading-relaxed">
          From the production team in our Nova Scotia facility to everyone sharing us online, Swole Bears is built by a whole crew.
        </p>
        <Link to="/story#team" data-testid="home-team-teaser-link" className="mt-7 inline-flex items-center gap-2 h-12 px-6 rounded-full bg-[#FFB21A] text-[#1B1530] font-bold hover:bg-white transition-colors">
          Meet the team <ArrowRight className="h-4 w-4" />
        </Link>
      </Reveal>
      <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-3">
        {CREW.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.06} data-testid={`home-team-chip-${i}`} className={`rounded-3xl bg-white/[0.06] border border-white/10 p-5 transition-transform duration-300 hover:-translate-y-1 ${i === 0 ? "col-span-2 sm:col-span-1" : ""} ${i === CREW.length - 1 ? "sm:col-span-2" : ""}`}>
            <span className="grid h-11 w-11 place-items-center rounded-2xl" style={{ background: c.color }}>
              <c.icon className="h-5 w-5 text-[#1B1530]" />
            </span>
            <p className="mt-4 font-display text-lg sm:text-xl leading-tight">{c.title}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
